import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.chart.projection.default.footer,
      padding: spacing.xs,
      borderRadius: constants.radius.button,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    text: {
      margin: 0,
      color: theme.chart.projection.default.text,
      marginLeft: spacing.xxs,
    },
  };

  return styles;
};
